import { Component, OnInit, Pipe, PipeTransform, NgZone, Inject} from '@angular/core';
import { FormControl, FormGroupDirective, NgForm, Validators } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';

import { ListService } from '../services/list.service';
import { LoginService } from '../services/login.service';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogTitle,
} from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';


/** Error when invalid control is dirty, touched, or submitted. */
export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

export interface DialogData {
  id: number;
  family_id: number;
  name: string;
  qty: number;
  checked: number;
  last_time_checked: any;
  removing: boolean;
  score: number;
}

/* {
    "id": 2437,
    "family_id": 1,
    "name": "10.5 gallon trash bags",
    "qty": null,
    "checked": 1,
    "last_time_checked": "2025-12-12 18:21:51",
    "removing": false,
    "score": 0
} */

@Component({
  selector: 'create-list-dialog',
  templateUrl: 'create-list-dialog.html',
})
export class DialogCreateList {

  constructor(
    public dialogRef: MatDialogRef<DialogCreateList>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData) {}

  onNoClick(): void {
    this.dialogRef.close();
  }

}

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  public newItem = "";
  searchText: string = "";
  showChecked:string = "all";
  showCheckedLagged:string = "all";
  name = "";

  constructor(public listService:ListService,
              private zone:NgZone,
              public loginService:LoginService,
              private router: Router,
              public dialog: MatDialog) {

    if (typeof localStorage.showChecked != "undefined") {
      let checked = localStorage.showChecked
      if (checked == -1) {
        checked = 'all';
      }
      if (checked == 0) {
        checked = 'unchecked';
      }
      if (checked == 1) {
        checked = 'checked';
      }
      this.showChecked = checked;
      this.showCheckedLagged = this.showChecked;
    }
    if (typeof localStorage.searchText != "undefined") {
      this.searchText = localStorage.searchText;
    }
  }

  ngOnInit() {
      if (!this.loginService.loggedIn) {
        this.router.navigate(['/login']);
      }
  }

  clearFilter() {
    this.searchText = "";
    localStorage.searchText = this.searchText;
  }


  addItem() {
    if (!this.searchText) {
      return;
    }
    this.zone.run(() => {
        this.listService.addItem(this.searchText);
        // this.newItem = "";
    });
  }

  onShowCheckedChanged(evt) {
    console.log("evt:", evt);
    this.zone.run(() => {
      console.log("RUN!")
      this.showCheckedLagged = evt;
      this.showChecked = evt;
      this.listService.showChecked = evt;
      this.listService.showList();
    });
    this.showCheckedLagged = evt;
    this.showChecked = evt;
    // this.showCheckedLagged = evt;
    // this.showChecked = evt.value;
    setTimeout(() => {
      localStorage.showChecked = evt;
    },1000);
  }

  onSearchTextChange(evt) {
    console.log("this.searchText:", this.searchText);
    localStorage.searchText = this.searchText;

  }

  createList() {
    const dialogRef = this.dialog.open(DialogCreateList, {
      data: {name: ""}
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed result:', result);
      // this.animal = result;
      this.listService.createList(result['name']);
    });
  }

}

